import { escapeRegExp } from "lodash";
import type { SearchSnippet } from "src/api/search";

// podświetlenie w renderze (po załadowaniu danych), bez mutowania DOM-u
export const highlightPhrase = (text: string, phrase: string) => {
	const query = phrase.trim();
	if (!query) return text;

	return text
		.split(new RegExp(`(${escapeRegExp(query)})`, "gi"))
		.map((part, index) => (index % 2 ? <mark key={index}>{part}</mark> : part));
};

// backend zwraca pozycję trafienia (łapie też odmiany, np. „cukrzycą”)
export const highlightSnippet = ({
	text,
	matchStart,
	matchLength,
}: SearchSnippet) => {
	const matchEnd = matchStart + matchLength;
	return (
		<>
			{text.slice(0, matchStart)}
			<mark>{text.slice(matchStart, matchEnd)}</mark>
			{text.slice(matchEnd)}
		</>
	);
};
